<script>
  export let goToQuestionnaire;
  let src = "./assets/YOU.gif";
  let name = "welcome";
</script>

<img {src} alt={name} />
<div><button on:click={goToQuestionnaire}> Start your test </button></div>

<style>
  img {
    height: 1294/2;
    width: 1172px/2;
    left: 0px;
    top: 0px;
  }
  button {
    width: 322px;
    height: 43px;
    left: 419px;
    top: 900px;
  }
</style>
